import { createContext, useContext } from "react";

/*
いま見ている人がログインしているか。リンクの札 (OGPLinkCard) が「ログインが必要です」と出すかどうかを決める。
値が無い (null) 場所は、公開の頁と同じく「ログインしていないかもしれない」として今までどおり出す。
ログインの要る頁の外枠 (/luagate の layout) が true を渡し、その中の本文の札はログイン済みの人に「ログインが必要です」と言わない
*/
export const ViewerAuthContext = createContext<boolean | null>(null);

export function useViewerSignedIn(): boolean | null {
  return useContext(ViewerAuthContext);
}
